module.exports = __webpack_public_path__ + "img/IMG_1242.cfd5dd59.jpeg";